/*
 * @Author: Json Chen
 * @Date: 2021-07-14 17:12:44
 * @LastEditTime: 2022-03-03 15:24:44
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/PickupLocations/Components/PickUpTime.tsx
 */
import { Checkbox, Form } from 'antd';
import React from 'react';
import TimePickerRangePicker from './TimePickerRangePicker';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { weekList } from './config';
import styles from './pickUpTime.module.less';

export { weekList };

const PickUpTime = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <React.Fragment>
      {weekList({ getI18n }).map((weekItem, weekIndex) => {
        return (
          <React.Fragment key={weekIndex}>
            <div className={styles.weekItem}>
              <Form.Item
                name={['customizes', weekIndex, 'checked']}
                valuePropName='checked'
                className={styles.checkbox}
                labelAlign='left'
                initialValue={weekItem.checked}>
                <Checkbox>
                  <span className={styles.checkboxText}>{weekItem.name}</span>
                </Checkbox>
              </Form.Item>
              <Form.Item
                className={styles.timePickerItem}
                shouldUpdate={(p, c) =>
                  p.customizes[weekIndex].checked !==
                  c.customizes[weekIndex].checked
                }>
                {({ getFieldValue }) => {
                  const disabled = !getFieldValue([
                    'customizes',
                    weekIndex,
                    'checked',
                  ]);
                  return (
                    <Form.Item
                      name={['customizes', weekIndex, 'range']}
                      initialValue={weekItem.range}>
                      <TimePickerRangePicker
                        getPopupContainer={(triggerNode) =>
                          triggerNode.parentNode
                        }
                        className={styles.timePickerInput}
                        size='large'
                        disabled={disabled}
                        allowClear={false} //是否展示清除按钮
                        format={'HH:mm'} //展示的时间格式 默认带 秒
                        dropdownClassName={styles.timePickerPopUp}
                      />
                    </Form.Item>
                  );
                }}
              </Form.Item>
            </div>
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};

export default PickUpTime;
